export const SET_MAIS_DETALHES_FIELD = "SET_MAIS_DETALHES_FIELD";
export const LOADING_MAIS_DETALHES = "LOADING_MAIS_DETALHES";
export const ERROR_MAIS_DETALHES = "ERROR_MAIS_DETALHES";